import { useUrl } from 'hooks/useUrl'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { ComponentType } from 'react'
import { GoChevronLeft, GoChevronRight } from 'react-icons/go'
import Paginating from 'react-paginating'
import { Pagination as BSP, PaginationItem, PaginationLink } from 'reactstrap'
import { stringifyQueryObject } from 'utils/query'

interface Props {
  total: number
  limit: number
  page: number
  loading?: boolean
  className?: string
}

export const Pagination: ComponentType<Props> = ({ total, limit, page, loading, className }) => {
  const router = useRouter()
  const { url, query } = useUrl()

  return (
    <Paginating total={total} limit={limit} pageCount={7} currentPage={page}>
      {({ pages, currentPage, hasPreviousPage, previousPage, hasNextPage, nextPage }) => {
        if (pages.length <= 1) {
          return null
        }

        return (
          <BSP className={className} listClassName="mb-0 justify-content-center">
            <PaginationItem disabled={!hasPreviousPage || loading}>
              {hasPreviousPage ? (
                <Link
                  href={router.route}
                  as={{
                    pathname: url.pathname,
                    search: stringifyQueryObject(query, {
                      page: previousPage,
                    }),
                  }}
                  passHref
                  shallow
                >
                  <a className="page-link">
                    <GoChevronLeft />
                  </a>
                </Link>
              ) : (
                <PaginationLink>
                  <GoChevronLeft />
                </PaginationLink>
              )}
            </PaginationItem>
            {pages.map(page => (
              <PaginationItem key={page} active={page === currentPage} disabled={loading}>
                <Link
                  href={router.route}
                  as={{
                    pathname: url.pathname,
                    search: stringifyQueryObject(query, { page }),
                  }}
                  passHref
                  shallow
                >
                  <a className="page-link">{page}</a>
                </Link>
              </PaginationItem>
            ))}
            <PaginationItem disabled={!hasNextPage || loading}>
              {hasNextPage ? (
                <Link
                  href={router.route}
                  as={{
                    pathname: url.pathname,
                    search: stringifyQueryObject(query, { page: nextPage }),
                  }}
                  passHref
                  shallow
                >
                  <a className="page-link">
                    <GoChevronRight />
                  </a>
                </Link>
              ) : (
                <PaginationLink>
                  <GoChevronRight />
                </PaginationLink>
              )}
            </PaginationItem>
          </BSP>
        )
      }}
    </Paginating>
  )
}
